import '../assets/Checkbox.css';
import { defineComponent, ref, openBlock, createElementBlock, withModifiers, unref, createVNode, createElementVNode } from 'vue';
import { d as debounce } from './debounce.CJgNZ1TL.js';
import { _ as _sfc_main$1 } from './Tooltip.vue_vue_type_style_index_0_lang.Xu8bM845.js';

const _hoisted_1 = ["checked", "disabled"];
const _hoisted_2 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Checkbox",
  props: {
    errorMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const checkmarkDom = ref();
    const isChecked = ref(props.checked);
    const errorTooltipRef = ref();
    function hideError() {
      errorTooltipRef.value.hide();
    }
    const onClick = debounce(() => {
      isChecked.value = !isChecked.value;
      hideError();
      emit("update:modelValue", isChecked.value);
    }, 200, { leading: true, trailing: false });
    function showError() {
      const {
        top,
        left,
        width
      } = checkmarkDom.value?.getBoundingClientRect() || {};
      errorTooltipRef.value.show(props.errorMessage, {
        top,
        left: left + width / 2
      });
    }
    function validate() {
      const isValid = !props.required || !!isChecked.value;
      if (!isValid) {
        showError();
      }
      return isValid;
    }
    __expose({
      validate,
      isChecked,
      id: props.id
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "tool--checkbox",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          //@ts-ignore
          (...args) => unref(onClick) && unref(onClick)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        (...args) => unref(onClick) && unref(onClick)(...args)),
        checked: isChecked.value,
        disabled: __props.disabled
      }, [
        createVNode(_sfc_main$1, {
          ref_key: "errorTooltipRef",
          ref: errorTooltipRef,
          "auto-hide": 3e3
        }, null, 512),
        createElementVNode("input", {
          id: props.id,
          class: "tool--checkbox__input",
          type: "checkbox"
        }, null, 8, _hoisted_2),
        createElementVNode("span", {
          class: "tool--checkbox__checkmark",
          ref_key: "checkmarkDom",
          ref: checkmarkDom
        }, null, 512)
      ], 40, _hoisted_1);
    };
  }
});

export { _sfc_main as _ };
//# sourceMappingURL=Checkbox.vue_vue_type_style_index_0_lang.Bl3jRwHI.js.map
